const userRouter = [
  {
    path: '/user/rich',
    name: 'UserRich',
    component: () => import('@/views/user/rich')
  },
  {
    path: '/user/ticket/record',
    name: 'UserTicketRecord',
    component: () => import('@/views/user/ticket_record')
  },
  {
    path: '/user/:id(\\d+)',
    name: 'UserDetail',
    component: () => import('@/views/user/detail')
  },
  {
    path: '/user/fav',
    name: 'UserFav',
    component: () => import('@/views/user/fav')
  }
]

export default userRouter



// WEBPACK FOOTER //
// ./src/router/modules/user.js